import {
  Box,
  Typography,
  Button,
  TextField,
  IconButton,
  InputAdornment,
  Link,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useFormik } from "formik";
import { useState, useEffect } from "react";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import { checkForUser } from "../_redux/authCrud";
import i18n from "./i18n";
import React from "react";
import mainLogo from "../../../../../src/_metronic/layout/components/header/header-menu/logo.png";
import moment from "moment";

const NewLogin1 = ({ loginTrue, setMail, mailId, selectedLanguage }) => {
  console.log("NewLogin1");
  const { t } = useTranslation();
  const masterAdminCheck =
    window.location.pathname.split("/")[1] === "masterAdmin" ? true : false;
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [invalid, setInvalid] = useState(false);

  useEffect(() => {
    i18n.changeLanguage(selectedLanguage);
  }, [selectedLanguage]);

  const LoginSchema = Yup.object().shape({
    email: Yup.string()
      .email(t("Enter correct mail Id"))
      .required(t("Email is required")),
  });
  const formik = useFormik({
    initialValues: { email: mailId },
    validationSchema: LoginSchema,
    onSubmit: async (values) => {
      validUser(values);
    },
  });

  const validUser = async (values) => {
    setLoading(true);
    setInvalid(false);
    try {
      let email_truncated = String(values.email).trim().toLowerCase();
      const resp = await checkForUser(email_truncated);
      if (resp.data === "User Present") {
        setMail(email_truncated);
        loginTrue();
      } else {
        setInvalid(true);
      }
    } catch (e) {
      setInvalid(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box display="flex" width="100vw" height="100vh">
      {/* LEFT 50% */}
      <Box
        flex={1}
        bgcolor="#121212"
        color="white"
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        px={4}
      >
        <img
          alt="logo"
          // src={imageData?.logoUrl}
          src={mainLogo}
          style={{ maxHeight: "100px", maxWidth: "150px", filter: "invert(1)" }}
        />
        <Typography
          variant="h6"
          mb={4}
          style={{ fontWeight: "bold", fontSize: "1.8rem" }}
        >
          {t("Truly all-in-one platform for hotels and vacation rentals")}
        </Typography>
        <Typography
          variant="h5"
          color="white"
          mb={2}
          style={{ marginTop: "10px", marginBottom: "6rem" }}
        >
          {t("empowering 3500+ hotels worldwide")}
        </Typography>
        <Typography variant="h5" color="gray" mb={2}>
          {t("Download our app")}
        </Typography>
        <Box display="flex" gap={2}>
          <div className="d-flex justify-content-between ">
            <img
              style={{
                height: "4rem",
                cursor: "pointer",
                width: "11rem",
                marginTop: "7px",
                borderRadius: "10px",
                border: "0.8px solid #A3A3A3",
              }}
              onClick={() => {
                window.open(
                  "https://apps.apple.com/us/app/stayflexi-orchestra/id1498345123",
                  "_blank"
                );
              }}
              src={
                "https://prodimagesbucket.blob.core.windows.net/misc/GPLAYS.png"
              }
            />
            <img
              style={{
                height: "73px",
                width: "12rem",
                cursor: "pointer",
                marginTop: "-5px",
              }}
              onClick={() => {
                window.open(
                  "https://play.google.com/store/apps/details?id=com.stayflexi.platform",
                  "_blank"
                );
              }}
              src={
                "https://prodimagesbucket.blob.core.windows.net/misc/5a902dbf7f96951c82922875.png"
              }
            />
          </div>
        </Box>
      </Box>

      {/* RIGHT 50% */}
      <Box flex={1} display="flex" flexDirection="column" px={6}>
        {/* Centered form */}
        <Box
          flexGrow={1}
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <Box
            component="form"
            noValidate
            onSubmit={formik.handleSubmit}
            sx={{ width: "100%", maxWidth: 400 }}
          >
            <Typography variant="h3" align="center" fontWeight="bold" mb={3}>
              Stayflexi
            </Typography>

            <TextField
              fullWidth
              autoFocus
              name="email"
              id="email"
              placeholder={masterAdminCheck ? t("Hotel Email") : t("Email")}
              value={formik.values.email}
              onChange={(e) => {
                formik.setFieldValue("email", e.target.value);
                if (invalid) setInvalid(false);
              }}
              onBlur={formik.handleBlur}
              error={
                (formik.touched.email && Boolean(formik.errors.email)) ||
                invalid
              }
              helperText={
                (formik.touched.email && formik.errors.email) ||
                (invalid && t("No user present"))
              }
              sx={{
                "& legend": { display: "none" }, // remove notch
              }}
              // label={masterAdminCheck ? t("Hotel Email") : t("Email")}
            />

            <Typography variant="body2" mt={2} mb={3}>
              {t("By clicking the Sign in button, you agree to Stayflexi’s")}{" "}
              <Link
                underline="hover"
                href="https://business.stayflexi.com/terms"
                to="https://business.stayflexi.com/terms"
                style={{ textDecoration: "underline" }}
                target="_blank"
              >
                Terms of Service
              </Link>
            </Typography>

            <LoadingButton
              fullWidth
              type="submit"
              loading={loading}
              variant="contained"
              sx={{
                height: "3rem",
                backgroundColor: "black",
                color: "white",
                py: 1.5,
                textTransform: "none",
              }}
            >
              {t("Sign In")}
            </LoadingButton>
          </Box>
        </Box>

        {/* Footer at bottom */}
        <Typography padding={2} align="center" sx={{ color: "#5C5C5C" }}>
          {`© ${moment().format("YYYY")} ${t(
            "Stayflexi, Inc. San Francisco, California"
          )}`}
        </Typography>
      </Box>
    </Box>
  );
};

export default NewLogin1;
